import {
  ActionIcon,
  Box,
  Group,
  Paper,
  Stack,
  Text,
  Image,
  SimpleGrid,
} from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import type { PhotoFile } from './PhotoInput';

export interface PhotosListItemProps {
  photos: PhotoFile[];
  onAction: (index: number) => void;
  readonly?: boolean;
}

export const PhotosListItem = ({
  photos,
  onAction,
  readonly = false,
}: PhotosListItemProps) => {
  const { t } = useTranslation(['patient-pages']);

  return (
    <Stack gap="xs">
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="sm">
        {photos.map((photo, index) => (
          <Paper
            key={photo.id || `${photo.timestamp.getTime()}-${photo.file.name}`}
            withBorder
            p="sm"
          >
            <Stack gap="xs">
              <Image
                src={photo.preview}
                alt={`${t('examination.images.photo', {
                  ns: 'patient-pages',
                  defaultValue: 'Photo',
                })} ${index + 1}`}
                height={150}
                fit="cover"
                radius="sm"
              />

              <Group justify="space-between" align="flex-start">
                <Box flex={1}>
                  <Text size="sm" fw={500} lineClamp={1}>
                    {photo.file.name}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {photo.source === 'camera'
                      ? t('photos.sourceCamera', {
                          ns: 'patient-pages',
                          defaultValue: 'Camera',
                        })
                      : t('photos.sourceUpload', {
                          ns: 'patient-pages',
                          defaultValue: 'Upload',
                        })}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {(photo.file.size / 1024 / 1024).toFixed(2)} MB
                  </Text>
                </Box>

                {!readonly && (
                  <ActionIcon
                    color="red"
                    variant="subtle"
                    size="sm"
                    onClick={() => onAction(index)}
                  >
                    <IconTrash size={16} />
                  </ActionIcon>
                )}
              </Group>
            </Stack>
          </Paper>
        ))}
      </SimpleGrid>
    </Stack>
  );
};
